import type { MouseEventHandler } from 'react';
import styled from 'styled-components';
import type { TextStyleValue } from '@elfsight/configurator-contracts';
import { Show } from '@elfsight/lib-utils';
import { Button } from '@elfsight/widget-ui';
import { getInvertedColor } from '@elfsight/widget-utils';
import { useLingui } from '@lingui/react/macro';
import { STYLE_DEFAULTS } from '../../common';
import { useWidgetDomainTexts } from '../domain-texts';

type PayButtonProps = {
  onClick: MouseEventHandler<HTMLButtonElement>;
  disabled?: boolean;
  color?: string;
  font?: TextStyleValue;
};

export function PayButton({
  onClick,
  disabled,
  color = STYLE_DEFAULTS.accentColor,
  font = { ...STYLE_DEFAULTS, fontWeight: 700 }
}: PayButtonProps) {
  const { t } = useLingui();
  const { payButtonActionText: actionText } = useWidgetDomainTexts();

  const invertedColor = getInvertedColor(color);

  return (
    <StyledButton
      color={color}
      onClick={onClick}
      fontColor={invertedColor}
      font={font}
      borderWidth={0}
      borderRadius={8}
      verticalPadding={12}
      horizontalPadding={22}
      disabled={disabled}
    >
      <Show when={!disabled} fallback={t`Processing Payment...`}>
        {actionText}
      </Show>
    </StyledButton>
  );
}

const StyledButton = styled(Button)`
  min-width: 200px;
  flex-shrink: 0;
  margin: 0 auto;

  // "disabled" override
  opacity: 1;
`;
